module.exports = __webpack_public_path__ + "img/kleisma3m.1257426e.jpg";